import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './StepperIntroStyles';

export default class Stepper extends Component {
  render() {
    return (
        <div className={css(styles.stepperWrapper)}>
          <div>
            <span className={css(styles.step, this.props.activeStep === 1 && styles.active)}>1</span>
            <p className={css(styles.descriptionMain)}>My Home</p>
          </div>
          <div>
            <span className={css(styles.step, this.props.activeStep === 2 && styles.active)}>2</span>
            <p className={css(styles.descriptionAssisted)}>Parents Home</p>
          </div>
        </div>
    );
  }
}
